/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MarkMatchCommandDto interface.
 */
export function instanceOfMarkMatchCommandDto(value) {
    if (!('matchId' in value) || value['matchId'] === undefined)
        return false;
    if (!('markAsRead' in value) || value['markAsRead'] === undefined)
        return false;
    return true;
}
export function MarkMatchCommandDtoFromJSON(json) {
    return MarkMatchCommandDtoFromJSONTyped(json, false);
}
export function MarkMatchCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'matchId': json['matchId'],
        'markAsRead': json['markAsRead'],
    };
}
export function MarkMatchCommandDtoToJSON(json) {
    return MarkMatchCommandDtoToJSONTyped(json, false);
}
export function MarkMatchCommandDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'matchId': value['matchId'],
        'markAsRead': value['markAsRead'],
    };
}
